/**
 * Empty state. Every screen has one before its content exists, and it says
 * what will appear there rather than apologising for the blank.
 */

import { icon } from '../js/icons.js'
import { text } from '../js/html.js'

export function emptyState({ icon: iconName, title, body }) {
  return `
    <div class="empty">
      <span class="empty__icon">${icon(iconName, { size: 28 })}</span>
      <h2 class="empty__title">${text(title)}</h2>
      <p class="empty__body">${text(body)}</p>
    </div>
  `
}
